import {
  Maybe,
  ServerAppSubscriptionStatusEnum,
  ServerGeneratePaddleCheckoutUrlResult,
  ServerGeneratePaddleCustomerPortalSessionUrlResult,
  ServerPaddleFunctionResult,
} from '../../generated/graphql-types'
import { CloudFunctionResponseCodes } from '../responses'

export enum PlanType {
  Unlimited = 'unlimited',
  Professional = 'professional',
  Basic = 'basic',
}

export interface PaddlePrice {
  id: string
  productId: string
  name: string | null
  description: string
  billingCycle: {
    interval: 'day' | 'week' | 'month' | 'year'
    frequency: number
  } | null
  customData: object | null
  unitPrice: {
    amount: string
  }
}

export interface PaddleProduct {
  id: string
  name: string
  description: string | null
  customData: object | null
  prices: PaddlePrice[]
}

export interface AppSubscriptionProduct extends PaddleProduct {
  customData: { planType: PlanType }
}

export interface CurrentBusinessSubscription {
  status: ServerAppSubscriptionStatusEnum
  planType: string
  createdAt: Date
  canceledAt: Date | null
  pausedAt: Date | null
}

export interface GetPaddleProductsFunctionResult extends ServerPaddleFunctionResult {
  code: CloudFunctionResponseCodes
  products: Maybe<PaddleProduct[]>
}

export interface GeneratePaddleCheckoutUrlFunctionResult
  extends ServerGeneratePaddleCheckoutUrlResult {
  code: CloudFunctionResponseCodes
}

export interface GeneratePaddleCustomerPortalSessionUrlFunctionResult
  extends ServerGeneratePaddleCustomerPortalSessionUrlResult {
  code: CloudFunctionResponseCodes
}
